import { Formik } from "formik";
import { LoginFormComponent, StyledLink, StyledReturnHomeLink, LoginLogo } from "@components";
import { IAuthLogin, ILogin } from "@interfaces";
import { loginSchema } from "@validations";
import { AppDispatch, loginV2, toggleLoading } from "@redux";
import { NavLink, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ErrorToast } from "src/Components/toasts/ErrorToast";
import { Link } from "react-router-dom";
import { loginHandle } from "src/Utilities/routeHelper";
import { PATH_HOME } from "@routes";
import { useEffect, useState } from "react";

export const Login = () => {
    const dispatch = useDispatch<AppDispatch>();
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [isAppleCallback, setIsAppleCallback] = useState(false);

    // Check if this is an Apple OAuth callback
    useEffect(() => {
        const idToken = searchParams.get("id_token");
        if (idToken) {
            setIsAppleCallback(true);
        }
    }, [searchParams]);

    const initialValues: ILogin = {
        email: process.env.REACT_APP_EMAIL || "",
        password: process.env.REACT_APP_PASSWORD || "",
    };

    return (
        <>
            <Link to={"/"}>
                <LoginLogo src="/images/logos/Primary_logo_color.svg" />
            </Link>
            <Formik
                initialValues={initialValues}
                validationSchema={loginSchema}
                onSubmit={async (values, { setSubmitting, setErrors }) => {
                    try {
                        dispatch(toggleLoading(true));
                        const res = (await dispatch(loginV2(values))) as {
                            payload: IAuthLogin;
                        };
                        //@ts-ignore
                        if (!res.payload.data.accessToken) {
                            setErrors({
                                password: "Please confirm username and password are correct",
                                email: "please confirm username and password are correct",
                            });
                        } else {
                            await loginHandle(
                                dispatch,
                                res.payload,
                                navigate,
                                location,
                                searchParams,
                                values.email,
                            );
                        }
                    } catch (error: any) {
                        ErrorToast({
                            Message: error.title || "An unexpected error occurred",
                        });
                    } finally {
                        setSubmitting(false);
                        dispatch(toggleLoading(false));
                    }
                }}
            >
                {({
                    values,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    errors,
                    touched,
                }) => {
                    return (
                        <div style={{ width: "100%" }}>
                            <LoginFormComponent
                                values={values}
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                handleSubmit={handleSubmit}
                                isSubmitting={isSubmitting}
                                errors={errors}
                                touched={touched}
                                isAppleCallback={isAppleCallback}
                            />
                        </div>
                    );
                }}
            </Formik>
            <StyledReturnHomeLink>
                <Link to={PATH_HOME}>Return to home</Link>
            </StyledReturnHomeLink>
            <StyledLink>
                Don't have an account? <NavLink to={"/signup" + location.search}> Sign up</NavLink>,
                to start saving today.
            </StyledLink>
        </>
    );
};
